import { UserConditionType } from '../../common/enums';

export class UserConditionTypeModel {
    public userConditionToUserConditionTypeId: number;
    public userConditionValue: string;
    public conditionDate: string;
}